<template>
  <span
    class="payment-status-badge"
    :style="{ color: display.color, backgroundColor: display.bgColor }"
  >
    <i :class="`fas ${display.icon} me-1`"></i>
    {{ display.label }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { getPaymentStatusDisplay } from '@/utils/paymentStatus';

const props = defineProps({
  status: { type: String, required: true },
});

const display = computed(() => getPaymentStatusDisplay(props.status));
</script>

<style scoped>
.payment-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}
</style>
